import { doc, runTransaction, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

const VISITOR_STORAGE_KEY = 'sharabl:visitor-id';
const sessionVisitorId = `session-${Math.random().toString(36).slice(2)}-${Date.now()}`;

const getVisitorId = () => {
  if (typeof window === 'undefined') return sessionVisitorId;

  try {
    const storedVisitorId = window.localStorage.getItem(VISITOR_STORAGE_KEY);
    if (storedVisitorId) return storedVisitorId;

    const nextVisitorId = window.crypto?.randomUUID
      ? window.crypto.randomUUID()
      : `visitor-${Math.random().toString(36).slice(2)}-${Date.now()}`;

    window.localStorage.setItem(VISITOR_STORAGE_KEY, nextVisitorId);
    return nextVisitorId;
  } catch (error) {
    return sessionVisitorId;
  }
};

const normaliseUniqueKey = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/\s+/g, ' ');

const trackUniqueMetric = async (linkId, {
  countField,
  keysField,
  timestampField,
  uniqueKey = getVisitorId(),
}) => {
  if (!linkId) return false;

  const resolvedUniqueKey = normaliseUniqueKey(uniqueKey);
  if (!resolvedUniqueKey) return false;

  const linkRef = doc(db, 'sharabl-links', linkId);

  return runTransaction(db, async (transaction) => {
    const snapshot = await transaction.get(linkRef);
    if (!snapshot.exists()) return false;

    const data = snapshot.data();
    const currentKeys = Array.isArray(data[keysField]) ? data[keysField] : [];
    if (currentKeys.includes(resolvedUniqueKey)) return false;

    transaction.update(linkRef, {
      [countField]: (Number(data[countField]) || 0) + 1,
      [keysField]: [...currentKeys, resolvedUniqueKey],
      [timestampField]: serverTimestamp(),
    });

    return true;
  });
};

export const linkAnalyticsService = {
  trackUniqueView(linkId, uniqueKey) {
    return trackUniqueMetric(linkId, {
      countField: 'views',
      keysField: 'viewKeys',
      timestampField: 'lastViewedAt',
      uniqueKey,
    });
  },

  trackUniqueShare(linkId, uniqueKey) {
    return trackUniqueMetric(linkId, {
      countField: 'shares',
      keysField: 'shareKeys',
      timestampField: 'lastSharedAt',
      uniqueKey,
    });
  },
};
